/**
 * Calculate bundle product stock status based on Magento rules
 * @param {Object} bundleProduct - The bundle product with items
 * @returns {string} 'IN_STOCK' or 'OUT_OF_STOCK'
 */
export const calculateBundleStockStatus = (bundleProduct) => {
  if (!bundleProduct?.items || bundleProduct.items.length === 0) {
    return 'OUT_OF_STOCK';
  }

  const hasRequiredOptions = bundleProduct.items.some(item => item.required);

  if (!hasRequiredOptions) {
    // All options are optional - check if at least one associated product is In Stock
    const hasInStockProduct = bundleProduct.items.some(item =>
      item.options?.some(option => option.product?.stock_status === 'IN_STOCK')
    );
    return hasInStockProduct ? 'IN_STOCK' : 'OUT_OF_STOCK';
  } else {
    // Some options are required - check if at least one product in each required option is In Stock
    const allRequiredOptionsHaveStock = bundleProduct.items.every(item => {
      if (!item.required) {
        return true; // Optional items don't affect bundle stock status
      }
      // For required items, at least one option must be in stock
      return item.options?.some(option => option.product?.stock_status === 'IN_STOCK');
    });
    return allRequiredOptionsHaveStock ? 'IN_STOCK' : 'OUT_OF_STOCK';
  }
};

/**
 * Format stock status for display
 * @param {string} stockStatus - Raw stock status (IN_STOCK, OUT_OF_STOCK, etc.)
 * @returns {Object} { text: string, className: string }
 */
export const formatStockStatus = (stockStatus) => {
  switch (stockStatus) {
    case 'IN_STOCK':
      return {
        text: 'In Stock',
        className: 'stock-status in-stock'
      };
    case 'OUT_OF_STOCK':
      return {
        text: 'Out of Stock',
        className: 'stock-status out-of-stock'
      };
    default:
      return {
        text: stockStatus || 'Unknown',
        className: 'stock-status unknown'
      };
  }
};